export const getSessionUser = (state) => state.models.session.sessionUser;
